import Lenis from "lenis";
import imagesLoaded from "imagesloaded";
// @ts-expect-error
import SimpleParallax from "simple-parallax-js/vanilla";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { varGutter } from "../utils/variables";
import { toggleFixedHeaderHide } from "../layout/header";

export let lenis: Lenis;

export async function initScroller() {
    lenis = new Lenis({
        duration: 1,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        wheelMultiplier: 1,
        infinite: false,
        prevent: node => {
            if (node.id === "mdp-readabler-popup-main") return true;
            return false;
        },
    });

    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add(time => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    initJumpLinksScrollTo();
    initScrollNextBtn();
    initParallax();

    setTimeout(checkInitialHash, 300);
}

function initParallax() {
    const parallaxEls = document.querySelectorAll<HTMLImageElement>("[data-u-scale]");

    imagesLoaded(parallaxEls).on("always", () => {
        const parallax = new SimpleParallax(parallaxEls, {
            scale: 1.15,
            delay: 0.1,
            orientation: "down",
            overflow: false,
            wrapper: ".main",
            customWrapper: ".parallax",
        });

        setTimeout(() => parallax.refresh(), 500);
    });
}

function initJumpLinksScrollTo() {
    const jumpLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

    jumpLinks.forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();

            if (location.pathname.replace(/^\//, "") === anchor.pathname.replace(/^\//, "") && location.hostname === anchor.hostname) {
                const targetId = anchor.hash;
                const target = document.querySelector(targetId) as HTMLElement;

                if (target) {
                    lenis.scrollTo(target, {
                        offset: -varGutter,
                        onComplete: () => toggleFixedHeaderHide("add"),
                    });
                    history.pushState(null, "", targetId);
                }
            }
        });
    });
}

function checkInitialHash() {
    const hash = window.location.hash;
    if (hash) {
        const target = document.querySelector<HTMLElement>(hash);
        if (target) {
            lenis.scrollTo(target, {
                offset: -varGutter,
                onComplete: () => toggleFixedHeaderHide("add"),
            });
        }
    }
}

function initScrollNextBtn() {
    const scrollNextBtns = document.querySelectorAll<HTMLElement>(".scroll-next");

    scrollNextBtns.forEach(btn => {
        btn.addEventListener("click", e => {
            e.preventDefault();

            const nextSection = btn.closest("section")?.nextElementSibling as HTMLElement;
            if (nextSection) {
                lenis.scrollTo(nextSection, {
                    offset: -varGutter,
                    onComplete: () => toggleFixedHeaderHide("add"),
                });
            }
        });
    });
}
